var _a, _b;
import { useRef } from "react";
import UAParser from "../utils/uaParser";
import VideoBasic from "./players/videoBasic";
import VideoCanvas from "./players/videoCanvas";
import VideoMpeg1, { loadJsMpeg } from "./players/videoMpeg1";
var useCanvas = false;
var useMpeg = false;
if (window) {
    var uaParser = new UAParser((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : "");
    useCanvas =
        uaParser.testUA("qqBrowser") ||
            (uaParser.testUA("ios") &&
                (uaParser.testUA("quark") || uaParser.testUA("baiduApp")));
    useMpeg =
        (uaParser.testUA("android") || uaParser.testUA("huawei")) &&
            (uaParser.testUA("wechat") || uaParser.testUA("baiduApp"));
    if (window && useMpeg)
        loadJsMpeg();
}
export var BackgroundVideo = useCanvas
    ? VideoCanvas
    : useMpeg
        ? VideoMpeg1
        : VideoBasic;
export var useVideoRef = function () { return useRef(null); };
